module.exports = __webpack_public_path__ + "img/AcademyShowAll2.5851213a.png";